import GoogleMapsApiLoader from 'google-maps-api-loader';

export default function dealers() {
    var wrapper = $('.dealers');
    var dealer_details = $('.dealers .dealer-details');

    var filters;
    var map;

    var dealer_markers = [];

    wrapper.on('filter', function(e, current_filters) {
        if (!map) {
            return;
        }

        if (current_filters) {
            filters = current_filters;
        }

        $.each(dealer_markers, function(i, dealer) {
            var show_dealer = true;

            $.each(filters, function(filter, values) {
                var filter_valid = false;

                $.each(values, function(i, value) {
                    if (dealer.data.tags.indexOf(filter + '-' + value) !== -1) {
                        filter_valid = true;
                        return false;
                    }
                });

                if (!filter_valid) {
                    show_dealer = false;
                    return false;
                }
            });

            dealer.setMap(show_dealer ? map : null);
            dealer.details.toggle(show_dealer);
        });
    });

    GoogleMapsApiLoader({
        libraries: ['places', 'geometry'],
        apiKey: 'AIzaSyDg58z7ZiPb39UWsfIjFIQGDusj01z7dz8'
    }).then(function(google) {
        var map_elem = $('.dealers .dealer-map');

        map = new google.maps.Map(map_elem.get(0), {
            center: {
                lat: -37.81,
                lng: 144.96
            },
            zoom: 12,
            minZoom: 4,
            mapTypeControl: false,
            streetViewControl: false
        });

        var popup = new google.maps.InfoWindow({
            disableAutoPan: true
        });

        var search_elem = $('.dealers .sidebar .search');

        var autocomplete = new google.maps.places.Autocomplete(search_elem.get(0), {
            types: ['(regions)'],
            componentRestrictions: {'country': 'au'}
        });

        autocomplete.addListener('place_changed', function() {
            var place = autocomplete.getPlace();

            if (place.geometry) {
                map.panTo(place.geometry.location);
                map.fitBounds(place.geometry.viewport);
            }
        });

        map.addListener('idle', function() {
            map_elem.toggleClass('disabled', map.getZoom() < 9);

            var center = map.getCenter();

            var radius = google.maps.geometry.spherical.computeDistanceBetween(
                center,
                map.getBounds().getNorthEast()
            );

            var popupContent = makeInterpolator(
                '<strong>{name}</strong><br><br>' +
                '{phone_national}<br><br>' +
                '{address_html}<br><br>'
            );

            var detailsContent = makeInterpolator(
                '<li>' +
                    '<strong class="details-name">{name}</strong>' +
                    '<p class="details-address">' +
                        '{address_html}<br><br>' +
                        '<a href="https://www.google.com/maps/dir/?api=1&destination={address_url}" target="_blank">Get directions &rarr;</a>' +
                    '</p>' +
                    '<p class="details-contact">' +
                        '<strong>Phone:</strong> <a href="tel:+{phone_e164}">{phone_national}</a><br>' +
                        '<strong>Website:</strong> <a href="{website}">{website}</a>' +
                    '</p>' +
                '</li>'
            );

            $.get(ajax_endpoint, {
                action: 'dealers',
                latitude: center.lat,
                longitude: center.lng,
                radius: Math.ceil(radius / 1000)
            }, function(response) {
                $.each(dealer_markers, function(i, marker) {
                    marker.setMap(null);
                    marker.details.remove();
                });

                dealer_markers = [];

                $.each(response, function(i, dealer) {
                    var marker = new google.maps.Marker({
                        position: {
                            lat: dealer.latitude,
                            lng: dealer.longitude
                        },
                        title: dealer.name,
                        data: dealer
                    });

                    marker.addListener('click', function() {
                        popup.open(map, marker);
                        popup.setContent(popupContent(dealer));
                    });

                    var details = $(detailsContent(dealer));

                    marker.details = details;

                    details.appendTo(dealer_details);

                    dealer_markers.push(marker);

                });

                wrapper.trigger('filter');
            });
        });

        var bounds = new google.maps.LatLngBounds(
            new google.maps.LatLng(-51.6633232, 100.0911072),
            new google.maps.LatLng(-0.6911344, 166.7429167)
        );

        var lastValidCenter = map.getCenter();

        google.maps.event.addListener(map, 'center_changed', function() {
            if (bounds.contains(map.getCenter())) {
                lastValidCenter = map.getCenter();
            } else {
                map.panTo(lastValidCenter);
            }
        });

        var map_style = new google.maps.StyledMapType(
            [{"elementType":"geometry","stylers":[{"color":"#f5f5f5"}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#f5f5f5"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#bdbdbd"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#dadada"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#c9c9c9"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]}]
        );

        map.mapTypes.set('styled_map', map_style);
        map.setMapTypeId('styled_map');
    });
}

function makeInterpolator(str) {
    var rc = {
        '\n': '\\n',
        '\"': '\\\"',
        '\u2028': '\\u2028',
        '\u2029': '\\u2029'
    };

    return new Function(
        'o',
        'return "' + (
            str.replace(/["\n\r\u2028\u2029]/g, function($0) {
                return rc[$0];
            }).replace(/\{([\s\S]+?)\}/g, '" + o["$1"] + "')
        ) + '";'
    );
}
